// extracted by mini-css-extract-plugin
export default {"logo":"logo_logo__lo2YB","label":"logo_label__nbemM","icon":"logo_icon__p3qTS","label--l":"logo_label--l__mZoWD","link":"logo_link__j7CCd"};